export class CreateTaskRequest {
    projectId?: string | null
    name?: string | null
    status?: string | null
    description?: string | null
    archives: TaskFile[] = [];
    analyses: Analysis[] = []
}

export class TaskFile{
    file: string = "";
    folder: string = "";
    originalName: string = "";
    size: string = "";
}

export class Analysis {
    name?: string | null
    parameters?: any
}